'use strict';
import * as $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dAccepted$002dSeen$0024 from "./app.data.types_drug$package$-Drug-Request-Accepted-Seen$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$43() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$43 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$43 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$43.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy25 = $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dAccepted$002dSeen$0024.$m_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy25, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBoolean);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$43 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$43, "app.api.DrugRequestsAcceptedListItem$$anon$43", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$43: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$43 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$43 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$43.js.map
